<div class="border-t border-black/5 p-4">
  @if (!loading()) {
    <bevvi-text-input
      [value]="value()"
      [placeholder]="placeholder()?.chat_placeholder_text || 'Enter your message'"
      (valueChange)="value.set($event)"
      (actionClick)="onSend()"
    />
  }

  <p class="mt-4 flex items-center justify-center gap-1.5 text-xs text-black/60">
    Powered by <img src="assets/images/logo.png" alt="bevvi" class="h-3.5 object-contain" />
  </p>
</div>
